import React, { useEffect, useState } from "react";
import { useSelectedZone } from "../../../hooks/useSelection";
import { createComponentAsync } from "../../bottom-menu/menu-loader";
import { BottomMenuIds } from "../../bottom-menu/paths";
import { useErrorHandling } from "../../../hooks/useErrorHandling";

import "./top-menu.css";
import { TextTopMenu } from "../text-top-menu/text-top-menu";

export const TopMenu = () => {
	const selectedZone = useSelectedZone();
	const { createFatalErrorHandler } = useErrorHandling();

	const [component, setComponent] = useState<React.ReactNode>(null);

	useEffect(() => {
		async function getMenuComponent() {
			let newComponent: React.JSX.Element | null = null;
			let bottomMenuId = null;
			if (selectedZone === undefined) {
				bottomMenuId = BottomMenuIds.None;
			} else if (
				eXpress.core.isPhotoZone(selectedZone) &&
				selectedZone.isZoneForPhotoSourceType("photo")
			) {
				bottomMenuId = BottomMenuIds.Photo;
			} else if (eXpress.core.isAnyTextZone(selectedZone)) {
				// TODO: Load async, bundle in text menu file
				newComponent = <TextTopMenu />;
			} else if (eXpress.core.isSymbolZone(selectedZone)) {
				bottomMenuId = BottomMenuIds.Symbols;
			} else if (
				eXpress.core.isPhotoZone(selectedZone) &&
				selectedZone.isZoneForPhotoSourceType("qr")
			) {
				bottomMenuId = BottomMenuIds.Qr;
			}

			// For BottomMenu based top menu's
			if (bottomMenuId !== null) {
				// Wrap with bottom-menu class for styling
				const comp = await createComponentAsync(bottomMenuId);
				newComponent = comp ? <div className="bottom-menu">{comp}</div> : null;
			}
			setComponent(newComponent);
		}

		getMenuComponent().catch(createFatalErrorHandler());
	}, [createFatalErrorHandler, selectedZone]);

	return <div className="top-menu">{component}</div>;
};
